import RouteTemplate from 'ember-route-template';

import { array } from '@ember/helper';
import { action } from '@ember/object';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

import addQueryParams from 'rise-ui/helpers/add-query-params.js';
import { apiUrl } from 'rise-ui/utils/external-api.js';

export default RouteTemplate(class RiseApiTemplate extends Component {
  @service ssr;

  apiUrl = apiUrl();

  @action frameInserted(el) {
    let id = el.getAttribute('id');
    if (!id) {
      id = 'iframe_' + Math.floor(Math.random() * 1000000000);
      el.setAttribute('id', id);
    }
    import('iframe-resizer').then(({ iframeResize }) => {
      iframeResize({}, '#' + id);
    });
  }

  <template>
    {{pageTitle "API"}}

    <h3 class="c-page-title qa-page-title">RISE API Documentation</h3>
    {{#unless this.ssr.isSsr}}
      <iframe class="c-rise-api" title="RISE API Documentation"
        src={{addQueryParams this.apiUrl (array (array "embed"))}}
        {{didInsert this.frameInserted}}
      ></iframe>
    {{/unless}}
    {{outlet}}
  </template>
});
